import {
  useQuery,
  type UseQueryOptions,
  type UseQueryResult
} from "@tanstack/react-query";

import type { GetRecurringOrderListRequestDto } from "../../dtos/get-recurring-order-list-request-dto";
import type { GetRecurringOrderListResponseDto } from "../../dtos/get-recurring-order-list-response-dto";
import { OrderQueryKeys } from "../../generators/order-query-keys";
import { OrderService } from "../../services/order-service";

type UseGetRecurringOrderListQueryProps = {
  queryParams: GetRecurringOrderListRequestDto;
  options?: UseQueryOptions<GetRecurringOrderListResponseDto>;
};

export const useGetRecurringOrderListQuery = ({
  queryParams,
  options
}: UseGetRecurringOrderListQueryProps): UseQueryResult<GetRecurringOrderListResponseDto> => {
  return useQuery({
    queryKey: OrderQueryKeys.getRecurringOrderList({ ...queryParams }).queryKey,
    queryFn: async () => {
      return await OrderService.getRecurringOrderList({ payload: queryParams });
    },
    ...options
  });
};
